import moment from "moment";
import { unparse as convertToCSV } from "papaparse/papaparse.min";
import {  downloadCsv } from "../../utils";


export const exporter = (data) => {
    const dataForExport = data.map((item) => ({
      "Usuário (Documento)": item.user.document,
      Ciclo: item.cycleId ? item.cycleId : "",
      Amostra: item.sample ? item.sample.name : "",
      Tipo: item.typeRate ? item.typeRate.name : "",
      Resposta: item.value,
      Laboratório: item.sample && item.sample.lab ? item.sample.lab.name : "",
      "Data de Criação": moment(item.createdAt).format("DD/MM/YYYY"),
    }));
  
    const csv = convertToCSV(
      {
        data: dataForExport,
        fields: [
          "Usuário (Documento)",
          "Ciclo",
          "Amostra",
          "Tipo",
          "Resposta",
          "Laboratório",
          "Data de Criação",
        ], 
      },
      {
        delimiter: ";",
      }
    );
  
    downloadCsv(csv, "feedbacks"); 
  };